import styled, { keyframes } from 'styled-components';
import breakpoints from 'base/constants/breakpoints';
import { colors } from 'theme/colors';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const shimmerBackground = `
  background: linear-gradient(
    90.22deg,
    #eaf6ff -17.61%,
    #e5d7fa 26.22%,
    #e5d7fa 70.06%,
    #dbf9f6 115.22%
  );
  background-size: 1000px 100%;
`;

export const EditOsrContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 70px;
  background: ${colors.syngentaNavy};
  box-sizing: border-box;
  justify-content: center;
  min-height: fit-content;
  position: relative;
  top: -10px;

  @media screen and ${breakpoints.maxWidth.sm} {
    padding: 16px;
  }
`;

export const EditOsrContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const EditOsrText = styled.span`
  color: ${colors.neutral00};
  text-align: left;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const EditOsrTextSkeleton = styled.span`
  display: block;
  flex: 1;
  height: 20px;
  border-radius: 8px;
  ${shimmerBackground}
  animation: ${shimmer} 2s infinite;
`;

export const EditOsrButtonSkeleton = styled.span`
  display: block;
  width: 170px;
  height: 40px;
  border-radius: 4px;
  margin-left: auto;
  flex-shrink: 0;
  ${shimmerBackground}
  animation: ${shimmer} 2s infinite;
`;

export const EditOsrButton = styled.button<{ $isMobile?: boolean }>`
  background: ${colors.green60};
  color: ${colors.neutral00};
  border: none;
  border-radius: 4px;
  padding: ${(props) => (props.$isMobile ? '15px 30px' : '10px 16px')};
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;

  &:hover {
    background: ${colors.green50};
  }
`;

export const EmailPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
`;

export const EmailPopupContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${colors.neutral00};
  border-radius: 8px;
  padding: 24px;
  width: 423px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: left;
  z-index: 9999;

  @media screen and ${breakpoints.maxWidth.xs} {
    width: calc(100vw - 32px);
    max-width: 95vw;
    padding: 16px;
  }
`;

export const EmailPopupTitle = styled.h2`
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  margin: 0 0 8px 0;
`;

export const EmailPopupBody = styled.p`
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 12px 0;
`;

export const EmailPopupInput = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  padding: 10px;
  margin-bottom: 4px;
  border: 1px solid ${(props) => (props.$hasError ? '#CF3537' : '#C2C7D0')};
  border-radius: 4px;
  box-sizing: border-box;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.$hasError ? '#CF3537' : colors.green60)};
  }
`;

export const EmailPopupError = styled.p`
  color: #cf3537;
  font-size: 12px;
  margin: 4px 0 12px 0;
`;

export const EmailPopupButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

export const EmailPopupCloseButton = styled.button`
  padding: 10px 16px;
  border: 1px solid #c2c7d0;
  border-radius: 4px;
  background: ${colors.neutral00};
  cursor: pointer;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;

  &:hover {
    background: #f5f5f5;
  }
`;

export const EmailPopupSubmitButton = styled.button`
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  background: ${colors.green60};
  color: ${colors.neutral00};
  cursor: pointer;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;

  &:hover {
    background: ${colors.green50};
  }

  &:disabled {
    background: #c2c7d0;
    cursor: not-allowed;
  }
`;
